import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();

  const menu = [
    {
      label: "Dashboard",
      path: "/admin/dashboard",
    },
    {
      label: "Retreat Types",
      path: "/admin/retreat-types",
    },
    {
      label: "Retreat Events",
      path: "/admin/retreats",
    },
    {
      label: "Blogs",
      path: "/admin/blogs",
    },
  ];

  return (
    <aside className="w-72 bg-secondary text-white min-h-screen">
      <div className="p-6 border-b border-white/10">
        <h2 className="text-2xl font-bold">
          Param CMS
        </h2>
      </div>

      <nav className="p-4">
        {menu.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`block p-4 rounded-xl mb-2 transition ${
              location.pathname.startsWith(item.path)
                ? "bg-white text-secondary"
                : "hover:bg-white/10"
            }`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
    </aside>
  );
}